export default __webpack_public_path__ + "static/media/castor.45b092ad.png";